import script from "./ContestApplicants.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestApplicants.vue?vue&type=script&setup=true&lang=js"

import "./ContestApplicants.vue?vue&type=style&index=0&id=cad7d5a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cad7d5a0"]])

export default __exports__